import type { Appearance } from "@stripe/stripe-js";
import { createInAppAppearance } from "./createInAppAppearance";
import { useThemeContextForStripeElements } from "./useThemeContext";

export const useInAppAppearance = (): Appearance => {
  const { stripeTheme } = useThemeContextForStripeElements();
  return createInAppAppearance(stripeTheme);
};
